export const CLASS_SCROLL_TEXT = 'scroll-text';
